import {
  ProductWasteStatisticsState,
  REQUEST_STOREWASTESTATISTICS_BY_PRODUCT,
  REQUEST_STOREWASTESTATISTICS_BY_PRODUCT_DONE
} from "./types";

const initialState: ProductWasteStatisticsState = {
  isLoading: true,
  productWasteStatistics: []
};

export function reducer(state = initialState, action: any) {
  switch (action.type) {
    case REQUEST_STOREWASTESTATISTICS_BY_PRODUCT:
      return {
        isLoading: true,
        productWasteStatistics: action.payload
      };
    case REQUEST_STOREWASTESTATISTICS_BY_PRODUCT_DONE:
      return {
        isLoading: false,
        productWasteStatistics: action.payload
      };
    default:
      return state;
  }
}
